export default __webpack_public_path__ + "static/media/discord-icon.8d65eb41.svg";